import { useEffect } from 'react';
import '../styles/masterScreenD16.css';

/**
 * Opts the mounted screen into the design16 look (masterScreenD16.css): `d16` on <body> while it is mounted.
 *
 * On <body> rather than the page because the screen's dialogs, menus and popups render into portals outside it;
 * removed on unmount, so the next screen -- every other master -- draws exactly as before. `enabled` false leaves it
 * off: a page shared with screens that keep their own look (Purchase Requests' View, also Default Template Forms').
 */
export function useD16Scope(enabled = true): void {
  useEffect(() => {
    if (!enabled) return undefined;
    document.body.classList.add('d16');
    return () => {
      document.body.classList.remove('d16');
    };
  }, [enabled]);
}
